import { render } from "./TheHomepage.vue?vue&type=template&id=5e233dca&scoped=true"
import script from "./TheHomepage.vue?vue&type=script&lang=js"
export * from "./TheHomepage.vue?vue&type=script&lang=js"

import "./TheHomepage.vue?vue&type=style&index=0&id=5e233dca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aurel\\Desktop\\new-website\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e233dca"]])

export default __exports__